module.exports = __webpack_public_path__ + "img/art5.c45c83f9.png";